import React from "react";
import { Grid, Header, Icon, Image, Segment } from "semantic-ui-react";

// Function to render a row with a given set of items
export const renderRow = (
  imageSize,
  items,
  columns,
  rowIndex,
  onRowClick = () => {},
  totalAlerts = 0,
) => {
  // Prevent rendering if there are no items or columns is 0
  if (!items || items.length === 0 || columns === 0) {
    return null;
  }

  return (
    <Grid.Row columns={columns} className="p-0_5 mt-1" key={`rows_${rowIndex}`}>
      {items.map((item, index) => (
        <Grid.Column
          textAlign="center"
          key={`dashboard_${index}`}
          className="px-0_5"
        >
          <Segment
            raised
            className={
              item.enabled ? "clickable br-1 m-0 h-100" : "br-1 m-0 h-100"
            }
            onClick={item.enabled ? () => onRowClick(item) : null}
            textAlign="center"
          >
            {item.icon && item.icon.endsWith(".png") ? (
              <Image
                src={`${process.env.PUBLIC_URL}/assets/icons/${item.icon}`}
                size={imageSize}
                className={item.enabled ? "m-a" : "m-a gray-scale"}
              />
            ) : (
              <Icon
                className="my-0_5 m-a"
                name={item.icon}
                size="big"
                disabled={!item.enabled}
              />
            )}
            {item.code === "ALERTS" && (
              <span
                className={
                  totalAlerts > 0
                    ? "notification-dot"
                    : "notification-dot bg-green"
                }
              >
                {totalAlerts}
              </span>
            )}
            <Header size="tiny" className="mt-0_5" disabled={!item.enabled}>
              {item.name}
              <Header.Subheader
                style={{ display: "inline", marginLeft: "5px" }}
              >
                {item.subHeader}
              </Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>
      ))}
    </Grid.Row>
  );
};
